import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';
import {TAisSignatoryDto} from 'store/slices/directories-company-slice/directories-company-slice-types';

export type TFetchAisSignatoriesArgs = {
    orgId: number;
}
export const fetchAisSignatories = (
    {orgId}: TFetchAisSignatoriesArgs,
) => performRequest<TAisSignatoryDto[]>(
    {
        url: `directories.signatories.structure/${orgId}`,
        method: ERequestType.GET,
    },
);

export type TPutAisSignatoriesArgs = {
    orgId: number;
    signatories: TAisSignatoryDto[];
}
export const putAisSignatories = (
    {orgId, signatories}: TPutAisSignatoriesArgs,
) => performRequest<string>(
    {
        url: `directories.signatories.structure/${orgId}`,
        method: ERequestType.PUT,
        data: {signatoriesDto: signatories},
    },
);
